// extracted by mini-css-extract-plugin
export default {"gridContainer":"Home_gridContainer__a5O33","parentContainer":"Home_parentContainer__OT8NU"};